import { useRouter } from "next/navigation";
import Image from "next/image";
import { useAppDispatch } from "lib/redux/hooks";
import { setImportComponentOpen } from "lib/redux/settingsSlice";
import CTABgSVG from "public/assets/heroIllustrations/ctaBgSVG.svg";
import ctaImg from "public/assets/heroIllustrations/ctaImg.webp";
// import AutofillBlackIcon from "public/assets/AutofillBlackIcon.svg";
import Link from "next/link";
import { cx } from "lib/cx";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import GetResumeScoreIcon from "public/icons/getResumeScore.svg"

export const Cta = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const handleResumeImport = () => {
    dispatch(setImportComponentOpen(true));
    router.push("/resume-builder");
  };
    const handleCheckScore = () =>{
   
    router.push("/upload-resume");
  }
  return (
    <section className="relative h-[140px] md:h-[200px] lg:h-[235px] xl:h-[280px] 2xl:h-[305px]">
      <div
        className={cx(
          "steps-shadow absolute left-1/2 top-0 z-10 -translate-x-1/2 overflow-hidden rounded-[20px] bg-white px-3 md:rounded-[44px] md:px-6",
          "w-[288px] md:w-[473px] lg:w-[630px] xl:w-[788px] 2xl:w-[946px]",
          "w-[133px] md:h-[169px] lg:h-[185px] xl:h-[231px] 2xl:h-[277px]"
        )}
      >
        <div className="relative flex h-full w-full items-center justify-between pt-2 md:pt-0">
          <CTABgSVG className="absolute -left-[7rem] -top-[7rem] hidden md:-left-[6rem] md:-top-[6rem] md:block lg:-left-[5rem] lg:-top-[5rem] xl:-left-14 xl:-top-14" />
          <div className="w-[65%] md:pt-8 xl:pt-10">
            <h2
              className={cx(
                "font-montserrat font-light text-[#52A1FF]",
                "text-[12.43px] md:text-[20.4px] lg:text-[27.2px] xl:text-[34px] 2xl:text-[40.8px]",
                "leading-[13.89px] md:leading-[20.8px] lg:leading-[30.4px] xl:leading-[38px] 2xl:leading-[45.6px]"
              )}
            >
              Ready to build your <br />
              <span className="font-normal">professional resume ?</span>
            </h2>
            <div
              className={cx(
                "hidden gap-2 pt-4 md:flex",
                "text-[9.9px] lg:text-[13.2px] xl:text-[16.5px] 2xl:text-[19.8px]"
              )}
            >
              <Link href="/resume-builder">
                <button className="btn-gradient rounded-[40px] px-2 py-1 font-poppins lg:px-4 xl:px-8 xl:py-2">
                  Generate Now <ArrowLongRightIcon className="h-6 w-6" />
                </button>
              </Link>
              <button
                className="flex items-center gap-2 rounded-[40px] px-2 py-1 font-poppins shadow-lg lg:px-4 xl:px-8 xl:py-2"
                onClick={handleResumeImport}
              >
              Get Resume Score <GetResumeScoreIcon className="h-6 w-6" />
              </button>
            </div>
          </div>
          <div className="flex h-full items-center">
            <div
              className={cx(
                "relative",
                "w-[80px] md:w-[131px] lg:w-[174px] xl:w-[218px] 2xl:w-[262px]",
                "h-[75px] md:h-[124px] lg:h-[165px] xl:h-[206px] 2xl:h-[247px]"
              )}
            >
              <Image
                src={ctaImg}
                alt="cta"
                fill={true}
                style={{ objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
        <div
          className={cx("my-2 flex justify-between md:hidden", "text-[10px]")}
        >
          <Link
            href="/resume-builder"
            className="btn-gradient items-center rounded-[40px] px-4 py-2 font-poppins"
          >
            Generate Now <ArrowLongRightIcon className="h-4 w-4" />
          </Link>
          <button
            className="flex items-center gap-2 rounded-[40px] px-2 py-2 font-poppins shadow-lg"
            onClick={handleResumeImport}
          >
            Get Resume Score <GetResumeScoreIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
      <div
        className={cx(
          "absolute bottom-0 w-full bg-[#87C5FF]",
          "h-[87px] md:h-[63px] lg:h-[84px] xl:h-[105px] 2xl:h-[126px]"
        )}
      ></div>
    </section>
  );
};
